import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatChipsModule } from '@angular/material/chips';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared.module';
import * as _ from 'lodash';
import { FilterDialogData } from '../../types/filter-dialog-data.type';
import { Selectable } from '../../types/selectable.type';
@Component({
	selector: 'bt-filter-list',
	standalone: true,
	imports: [MatDialogModule, MatIconModule, FormsModule, MatFormFieldModule, MatButtonModule, MatInputModule, MatCheckboxModule, MatChipsModule, CommonModule, SharedModule],
	templateUrl: './filter-list.component.html',
	styleUrl: './filter-list.component.scss'
})
export class FilterListComponent<T> implements OnInit {
	readonly #destroyRef = inject(DestroyRef);
	readonly #dialogRef = inject(MatDialogRef<FilterListComponent<T>>);
	public data = inject<FilterDialogData<T>>(MAT_DIALOG_DATA);
	readonly filterSize = 50;

	datasource: Array<Selectable<T>> = [];
	searchFilter: string = '';

	get datasourceSelected(): Array<Selectable<T>> {
		const selected = this.datasource.filter((el) => el.selected);

		this.data.selected.forEach((el) => {
			if (!selected.some((sel) => sel.displayId == el.displayId)) selected.push(el);
		});
		return selected;
	}

	ngOnInit(): void {
		this.data.filterService.preloadUntilSelected(this.data.selected, this.searchFilter, this.data.variables);

		this.data.filterService.datasource.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe({
			next: (datasource) => {
				this.datasource = datasource.map((el) => ({
					...el,
					selected: this.data.selected?.length ? this.data.selected.some((sel) => sel.displayId === el.displayId) : false
				}));
			},
			error: () => {
				console.log('err');
			}
		});
	}

	search(): void {
		const pagination = !!this.data.variables ? this.data.variables : { first: 50 };

		this.data.filterService.search(this.searchFilter, pagination, false);
	}

	onClick(item: Selectable<T>): void {
		if (this.data.singleSelection && !item.selected && this.data.selected.length) {
			this.onRemove(this.data.selected[0]);
		}

		if (!item.selected) {
			this.data.selected.push({ ...item, selected: true });
			this.data.filterService.toggleSelection(item);
		} else this.onRemove(item);
	}

	onRemove(item: Selectable<T>): void {
		const index = this.data.selected.findIndex((el) => el.displayId === item.displayId);
		this.data.selected.splice(index, 1);
		this.data.filterService.toggleRemoveSelection(item);
	}

	onClose(): void {
		this.#dialogRef.close();
	}

	inViewportAction(ev: any, element: Selectable<T>) {
		if (ev.isVisible) {
			const index = this.datasource.findIndex((el) => el.displayId === element.displayId);

			if (index === this.datasource.length - 1) {
				this.data.filterService.loadNextPage();
			}
		}
	}

	selectAll(): void {
		this.datasource.forEach((element) => {
			if (!element.selected) {
				this.onClick(element);
			}
		});
	}

	selectNone(): void {
		this.datasource.forEach((element) => {
			if (element.selected) {
				this.onRemove(element);
			}
		});
	}
}
